<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-header-title">أضافة اختبار</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="addNewExam()">
              <div class="card-body__form">
                <!-- Exam Main Info -->
                <div class="row">
                  <!-- Exam Title -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamTitle">عنوان الاختبار</label>
                      <input
                        type="text"
                        class="form-control mt-2"
                        id="ExamTitle"
                        placeholder="عنوان الاختبار"
                        v-model="exam.title"
                        required
                      />
                    </div>
                  </div>
                  <!-- Exam Duration -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamDuration">مدة الاختبار</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="ExamDuration"
                        min="1"
                        placeholder="مدة الاختبار بالدقائق"
                        v-model="exam.duration"
                        required
                      />
                    </div>
                  </div>
                  <!-- Exam Degree -->
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for="ExamDegree">مجموع الاختبار</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="ExamDegree"
                        placeholder="مجموع الاختبار"
                        :value="totalDegree"
                        readonly
                      />
                      <small class="text-muted">يتم حسابه من درجات الاسئلة</small>
                    </div>
                  </div>
                  <!-- Show Correct Answer -->
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for="examCorrectAnswer"
                        >امكانية عرض الاجابات الصحيحة</label
                      >
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="exam.showCorrectAnswer"
                      >
                        <option selected disabled value="">
                          امكانية عرض الاجابات الصحيحة
                        </option>
                        <option :value="false">لا تعرض الاجابات الصحيحة</option>
                        <option :value="true">عرض الاجابات الصحيحة</option>
                      </select>
                    </div>
                  </div>
                  <!-- Status -->
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for="examStatus">حالة الاختبار</label>
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="exam.status"
                      >
                        <option selected disabled value="">
                          اختار حالة الاختبار
                        </option>
                        <option :value="0">حفظ داخل مسودة</option>
                        <option :value="1">نشر</option>
                      </select>
                    </div>
                  </div>
                  <!-- Is Repeat Exam -->
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for="examRepeat">امكانية اعادة الاختبار</label>
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="exam.isRepeat"
                      >
                        <option selected disabled value="">
                          امكانية اعادة الاختبار
                        </option>
                        <option :value="false">لا يمكن اعادة الاختبار</option>
                        <option :value="true">يمكن اعادة الاختبار</option>
                      </select>
                    </div>
                  </div>

                  <!-- Exam Start -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamStartDate">بداية الاختبار</label>
                      <input
                        type="datetime-local"
                        class="form-control mt-2"
                        id="ExamStartDate"
                        placeholder="بداية الاختبار"
                        :min="today"
                        v-model="exam.start_date"
                        required
                      />
                    </div>
                  </div>
                  <!-- Exam End -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamEndDate">نهاية الاختبار</label>
                      <input
                        type="datetime-local"
                        class="form-control mt-2"
                        id="ExamEndDate"
                        placeholder="نهاية الاختبار"
                        v-model="exam.end_date"
                        :min="today"
                        required
                      />
                    </div>
                  </div>
                </div>

                <ExamQuestionsEditor v-model:questions="exam.questions">
                  <template #aside>
                        <!-- Add Categories Select -->
                        <div class="categories__select">
                          <div
                            class="categories__select__data"
                            v-show="this.categories.length > 0"
                          >
                            <div class="row">
                              <div class="col-lg-6">
                                <div class="form-group">
                                  <label>التصنيف</label>
                                  <select
                                    class="form-select form-control mt-2"
                                    id="mainCategory"
                                    aria-label="Default select "
                                    @change="onSelectMainCategory($event)"
                                  >
                                    <option selected disabled :value="0">
                                      اختار التصنيف
                                    </option>
                                    <option
                                      v-for="category in this.Maincategories"
                                      :key="category.category_id"
                                      :value="category.title"
                                    >
                                      {{ category.title }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      required
                                      id="subCategory"
                                      @change="onSelectSubCategory($event)"
                                    >
                                      <option selected disabled :value="0">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                              <div class="col-lg-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSubSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      @change="onSelectSubSubCategory($event)"
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSubSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                              <div class="col-lg-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSubSubSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      @change="
                                        onSelectSubSubSubCategory($event)
                                      "
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSubSubSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                            </div>
                          </div>
                          <div
                            v-show="this.categories.length == 0"
                            class="categories__select__noData pt-3"
                          >
                            <p>اختار التصنيف:</p>
                            <h6 class="text-center pb-3">
                              لا يوجد تصنيفات حتى الآن
                            </h6>
                          </div>
                        </div>
                        <!-- Add Categories Select -->
                  </template>
                </ExamQuestionsEditor>
              </div>

              <div class="card-footer">
                <button type="submit" class="btn btn-primary">حفظ</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";

// Swal
import Swal from "sweetalert2";

// Shared question form + questions table + edit modal
import ExamQuestionsEditor from "@/components/ExamQuestionsEditor.vue";
import { questionsTotalDegree } from "@/constants/exam";

export default {
  name: "AddExam",
  components: {
    ExamQuestionsEditor,
  },
  data() {
    return {
      // min Value in input date
      today: new Date().toISOString().substr(0, 10),
      exam: {
        type: 3, // exams
        status: 1,
        title: "",
        duration: "",
        degree: "",
        start_date: "",
        end_date: "",
        isRepeat: true,
        showCorrectAnswer: false,
        categories: [],
        questions: [],
        fullCategoriesInfo: [],
      },
      categories: [],

      // Get Categories has Main
      Maincategories: [],
      // Loop for Categories
      selectedCategory: null,
      selectedSubCategory: null,
      selectedSubSubCategory: null,

      // Save Result loop Categories
      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],
    };
  },
  methods: {
    ...mapActions("examsModule", ["addExam"]),

    async addNewExam() {
      if (this.exam.questions.length === 0) {
        this.showError("قم بأضافة سؤال واحد على الأقل");
        return;
      }

      // The exam total is always the sum of its questions' marks.
      this.exam.degree = this.totalDegree;

      try {
        await this.addExam(this.exam);
        this.$router.go(-1);
      } catch (error) {
        console.error("Could not save the exam", error);
        this.showError("لم يتم حفظ الاختبار، حاول مرة اخرى");
      }
    },

    showError(title) {
      Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      }).fire({ icon: "error", title });
    },

    //-----------------------------------------------------//
    // Get Categories
    ///// Get Main Category
    onSelectMainCategory($event) {
      let title = $event.target.value;
      this.selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];
      this.exam.categories = [];
      this.exam.fullCategoriesInfo = [];

      // Choose Sub Category
      if (this.selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...this.selectedCategory.sub_categories);
      }
      this.exam.categories.push(this.selectedCategory.category_id);
      this.exam.fullCategoriesInfo.push(this.selectedCategory);

      // console.log("subSelect", this.subSelect);
      document.getElementById("subCategory").value = 0;
    },
    ///// Get Sub Category
    onSelectSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.exam.categories.splice(1, 1);
      this.exam.fullCategoriesInfo.splice(1, 1);

      if (this.selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...this.selectedSubCategory.sub_categories);
      }
      this.exam.categories.push(this.selectedSubCategory.category_id);
      this.exam.fullCategoriesInfo.push(this.selectedSubCategory);

      console.log("subSubSelect exam", this.exam);
    },
    ///// Get Sub Sub Category
    onSelectSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSubSelect = [];
      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }

      // Delete if Change
      this.exam.categories.splice(2, 1);
      this.exam.fullCategoriesInfo.splice(2, 1);
      // Add New Value
      this.exam.categories.push(this.selectedSubSubCategory.category_id);
      this.exam.fullCategoriesInfo.push(this.selectedSubSubCategory);

      console.log("subSubSelect exam", this.exam);
    },

    ///// Get Sub Sub  Sub Category
    onSelectSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.exam.categories.splice(3, 1);
      this.exam.fullCategoriesInfo.splice(3, 1);
      this.exam.categories.push(this.selectedSubSubSubCategory.category_id);
      this.exam.fullCategoriesInfo.push(this.selectedSubSubSubCategory);
    },
    //-----------------------------------------------------//
  },

  created() {
    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
  },
  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),

    // Never typed by hand: the exam total is the sum of the question marks.
    totalDegree() {
      return questionsTotalDegree(this.exam.questions);
    },
  },
  mounted() {
    this.categories = this.getCategories;
    const mainCategory = document.getElementById("mainCategory");
    if (mainCategory) mainCategory.value = 0;
  },
  watch: {
    getCategories() {
      this.categories = this.getCategories;
    },
  },
};
</script>

<style lang="scss" scoped></style>
